/** Company-id flags. Not translatable — keep out of locale trees. */
export const companiesWithUserRolesManagement = [1, 3, 5, 55, 79, 103, 133, 146, 152, 154, 166, 184, 194, 195];
